import React from "react";
import "./components/InnovationStudio.css";

const InnovationStudioPage = () => {
  return (
    <section className="innovation-page">

      {/* HERO */}
      <div className="container innovation-hero">

        <h1>Innovation Studio</h1>

        <h2 className="gold">
          Strategic participation in future-facing ventures
        </h2>

        <p>
          Alongside advisory work, Karma & Delta may selectively engage in proprietary,
          own-account participation in innovation-led opportunities that fit our strategic focus.
        </p>

        <p>
          This is not a public capital-raising platform and not an invitation to invest.
          It reflects our long-term interest in helping shape ideas and ventures at the
          intersection of AI, research systems, synthetic data, synthetic personas,
          digital infrastructure, and innovation-driven business models.
        </p>

      </div>

      {/* THREE COLUMN SECTION */}
      <div className="container innovation-grid">

        {/* WHAT THIS MEANS */}
        <div className="innovation-card">
          <h3>What This Means</h3>
          <div className="yellow-line"></div>

          <ul>
            <li>Internal incubation of ideas</li>
            <li>Selective own-account exposure to aligned ventures</li>
            <li>Strategic collaboration with founders and product builders</li>
            <li>Advisory-led involvement in early-stage innovation themes</li>
          </ul>
        </div>

        {/* AREAS OF INTEREST */}
        <div className="innovation-card">
          <h3>Areas of Interest</h3>
          <div className="yellow-line"></div>

          <ul>
            <li>Artificial intelligence applications</li>
            <li>Synthetic persona and simulation systems</li>
            <li>Research technology</li>
            <li>Decision-support platforms</li>
            <li>Digital knowledge infrastructure</li>
            <li>Insight and analytics products</li>
          </ul>
        </div>

        {/* OPERATING PRINCIPLE */}
        <div className="innovation-card">
          <h3>Our Operating Principle</h3>
          <div className="yellow-line"></div>

          <p>
            We approach innovation participation with a strategic, long-horizon mindset.
            Any such activity is undertaken selectively, on a proprietary basis,
            and in a manner consistent with our business scope and legal obligations.
          </p>

          <p className="micro-disclaimer">
            Nothing on this website constitutes investment solicitation,
            investment advice, or regulated financial promotion.
          </p>
        </div>

      </div>

    </section>
  );
};

export default InnovationStudioPage;